import { useDispatch, useSelector } from 'react-redux'
import { VNDialog } from '../../../VNCustomerFacingDisplay/components/VNDialog'
import { setCFDPairedDialogOpen } from '../../ActionCreators'
import { getCFDPairedDialogOpen } from '../../Selectors'

export const VNCFDPairedDialog = () => {
  const dispatch = useDispatch()
  const isCFDPairedModalOpen = useSelector(getCFDPairedDialogOpen)

  return (
    <VNDialog
      open={isCFDPairedModalOpen}
      subtitleVariant={'h5'}
      title={'Card Reader Communication Error.'}
      subTitle={'Reconnect Card Reader and Retry.'}
      save={'OKAY'}
      onSave={() => dispatch(setCFDPairedDialogOpen(false))}
      fullWidth
      height={460}
      width={624}
    />
  )
}
